import React from "react";

export const NoPageFound = () => {
  return (
    <div>
      <h1>No Page Fond</h1>
    </div>
  );
};
